<template>
  <div
    class="benefit-wrapper pt-100 mb-pt-60 mb-pb-60 relative"
  >
    <div class="container">
      <div class="flex mb-200 mb-flex-wrap mb-flex-column-reverse mb-mb-60">
        <div class="wp-100 maxw-430 mt-50 mr-100 mb-mt-100 mb-mr-0">
          <h2 class="black fs-36 lh-36 fw-900 mb-30 mb-fs-28 mb-lh-28">
            <slot name="titleFirst"></slot>
          </h2>
          <div class="black fs-16 lh-24">
            <slot name="contentFirst"></slot>
          </div>
        </div>
        <div class="wp-100 relative mb-maxw-400 mb-m-auto">
          <div class="mb-w-280">
            <slot name="imageLargeFirst"></slot>
            <slot name="imageSmallFirst"></slot>
          </div>
        </div>
      </div>
      <div class="flex mb-flex-wrap">
        <div class="relative mr-100 mb-mr-0">
          <div class=""><slot name="imageSecond"></slot></div>
        </div>
        <div class="wp-100 mt-50">
          <h2 class="black fs-36 lh-36 fw-900 mb-30 mb-fs-28 mb-lh-28">
            <slot name="titleSecond"></slot>
          </h2>
          <div class="black fs-16 lh-24">
            <slot name="contentSecond"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="benefit">
    <div class="container flex mb-flex-wrap">
      <div class="wp-100 maxw-350 mr-100 mb-mr-0">
        <h2 class="black fw-900 fs-36 lh-36 mb-30 mb-fs-28 mb-lh-28">Benefits</h2>
        <div class="black fs-16 lh-24">
          Travel Agents choose Designer Journeys because we provide an extraordinary experience, from the planning stages through to travel.<br><br>
          With Designer Journeys, you will be be able to deliver your clients premium experiences with on-the-ground support that they won't find anywhere else.
        </div>
      </div>
      <div class="flex flex-wrap mt-70 mb-mt-30 benefit-item" style="gap: 30px 50px">
        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/network.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">
            Global Network of Trusted Local Designers
          </div>
        </div>
        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/position.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">
            Fully Customisable and Private Travel Options
          </div>
        </div>

        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/industry.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">
            Industry Accredited Provider
          </div>
        </div>
        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/secure.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">Secure Booking Platform with Price Guarantee on Deposit</div>
        </div>
        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/support.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">
            In-Destination Support for Your Clients and Travel Concierge Support </div>
        </div>
        <div class="w-200 mb-wp-100 mb-flex items-center">
          <img src="https://s3-cdn.designerjourneys.com/static/images/user/icon/maketing.svg" class='h-35' />
          <div class="fs-16 lh-24 black mt-10 mb-ml-20">
            Marketing Support
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.benefit {
  background: rgba(164, 203, 250, 0.15);
  position: relative;
  padding: 200px 110px 110px 110px;
  top: -100px;
  z-index: -1;
  height: 582px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@include phone{
  .benefit {
    padding: 60px 20px;
    position: relative;
    top: auto;
    height: auto;
  }
  .benefit-item img {
    width: 30px;
    height: auto;
  }
}
</style>
